



































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import gql from 'graphql-tag';

const GET_PARTY_FROM_GUEST_NAME = gql`
  query GetPartyFromGuestName($guestName: String!) {
    invite_list(where: {party_members: {name: {_ilike: $guestName}}}) {
      id
      party_name
      party_size
      rsvp
      comments
      party_members {
        id
        name
        attending
      }
    }
  }
`;

const RSVP_PEOPLE = gql`
  mutation RsvpPeople($partyId: uuid!, $peopleAttending: [uuid!], $comments: String!) {
    update_people(where: {id: {_in: $peopleAttending}}, _set: {attending: true}) {
      affected_rows
      returning {
        name
        party_id
        attending
        id
      }
    }
    update_invite_list(where: {id: {_eq: $partyId}}, _set: {rsvp: true, comments: $comments}) {
      affected_rows
      returning {
        id
        rsvp
        party_name
        comments
      }
    }
  }
`;

@Component({
  name: 'rsvp',
  components: {},
  apollo: {
    invitedParty: {
      query: GET_PARTY_FROM_GUEST_NAME,
      manual: true,
      skip: true,
      deep: true,
      variables() {
        return {
          guestName: this.guestNameToQuery
        };
      },
      result({ data, loading }) {
        if (!loading) {
          if (data.invite_list.length) {
            this.invitedParties = data.invite_list;
            if (this.invitedParties.length === 1) {
              this.invitedParty = Object.assign({}, data.invite_list[0]);
            }
            this.couldNotFindParty = false;
          } else {
            this.invitedParty = null;
            this.invitedParties = [];
            this.couldNotFindParty = true;
          }
          // this.$apollo.queries.invitedParty.skip = true;
        }
      },
    },
  }
})
export default class RsvpPage extends Vue {
  guestName: string = '';
  guestNameToQuery: string = '';
  partyId: string | null = null;
  partyName: string | null = null;
  partyMembers: any[] = [];
  invitedParty: any | null = null;
  invitedParties: any[] = [];
  comments: string = '';
  couldNotFindParty: boolean = false;
  couldNotRsvp: boolean = false;
  loadingRsvp: boolean = false;
  rsvpSuccessful: boolean = false;

  getPartyFromGuestName() {
    this.clearVars();
    this.guestName = this.guestName.trim().replace(/\s\s+/g, ' ');
    this.guestNameToQuery = this.guestName;
    this.$apollo.queries.invitedParty.skip = false;
    this.$apollo.queries.invitedParty.refetch();
  }

  get disableRsvp() {
    return this.partyMembers.some((member: any) => member.attending === null);
  }

  @Watch('guestName')
  clearIfEmpty() {
    if (this.guestName.length === 0) {
      this.clearVars();
    }
  }

  @Watch('invitedParty')
  updatePartyInfo() {
    if (this.invitedParty) {
      this.partyId = this.invitedParty.id;
      this.partyName = this.invitedParty.party_name;
      // if they haven't RSVP'd yet, set member.attending to null
      if (this.invitedParty.rsvp === false) {
        this.invitedParty.party_members.forEach((member: any) => {
          member.attending = null;
        });
      }
      this.partyMembers = this.invitedParty.party_members;
      this.comments = this.invitedParty.comments;
    } else {
      this.clearVars();
    }
  }

  selectParty(party: any) {
    this.invitedParty = party;
    this.invitedParties = [party];
  }

  updateRsvpStatus(member: any, attending: boolean) {
    member.attending = attending;
  }

  clearVars() {
    this.invitedParty = null;
    this.invitedParties = [];
    this.partyId = null;
    this.partyName = null;
    this.partyMembers = [];
    this.couldNotFindParty = false;
    this.couldNotRsvp = false;
    this.rsvpSuccessful = false;
  }

  submitRsvp() {
    this.loadingRsvp = true;
    this.couldNotRsvp = false;
    const peopleAttending = this.partyMembers
      .filter((member: any) => member.attending)
      .map((member: any) => member.id);
    this.$apollo.mutate({
      mutation: RSVP_PEOPLE,
      variables: {
        partyId: this.partyId,
        peopleAttending,
        comments: this.comments
      }
    }).then((data) => {
      this.loadingRsvp = false;
      this.rsvpSuccessful = true;
    }).catch((error) => {
      this.couldNotRsvp = true;
    });
  }
}
